import { defineComponent as i, createElementBlock as l, createCommentVNode as p, unref as u, openBlock as f, normalizeStyle as m, normalizeClass as c, createElementVNode as n, withModifiers as y } from "vue";
import { useIsEditable as g } from "../hooks/useIsEditable.js";
const w = /* @__PURE__ */ i({
  __name: "EditorHandle",
  props: {
    getPos: { type: Function },
    node: {},
    editor: {},
    shift: {},
    centered: { type: Boolean }
  },
  setup(r) {
    const e = r;
    function s() {
      return e.node.type.name === "callout" || e.node.type.name === "paragraph" ? 0 : 1;
    }
    const d = () => {
      const o = e.getPos() + e.node.nodeSize - s();
      e.editor.commands.focus("start"), e.editor.chain().insertContentAt(o, { type: "paragraph" }).run();
    }, { isEditable: a } = g(e.editor);
    return (o, t) => u(a) ? (f(), l("div", {
      key: 0,
      class: c(["editor-node-handles", { "editor-node-handles-centered": o.centered }]),
      contenteditable: "false",
      style: m({ top: o.shift })
    }, [
      n("button", {
        class: "add-node",
        contenteditable: "false",
        tabindex: "-1",
        type: "button",
        onClick: t[0] || (t[0] = y((b) => d(), ["stop"]))
      }, t[1] || (t[1] = [
        n("svg", {
          viewBox: "0 0 48 48",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          n("g", {
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            transform: "scale(3.42857)"
          }, [
            n("line", {
              x1: "7",
              x2: "7",
              y1: ".5",
              y2: "13.5"
            }),
            n("line", {
              x1: ".5",
              x2: "13.5",
              y1: "7",
              y2: "7"
            })
          ])
        ], -1)
      ])),
      t[2] || (t[2] = n("div", {
        class: "drag-handle",
        "data-drag-handle": "",
        role: "button"
      }, null, -1))
    ], 6)) : p("", !0);
  }
});
export {
  w as default
};
